export const engagementReportBuilder2Tags = "/engagement/report_builder_2/:app_group_id/tags";
